'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var REGISTRATION_STEP_FORM = exports.REGISTRATION_STEP_FORM = 'REGISTRATION_STEP_FORM';
var REGISTRATION_STEP_CONFIRMED = exports.REGISTRATION_STEP_CONFIRMED = 'REGISTRATION_STEP_CONFIRMED';
var REGISTRATION_STEP_CONFIRMED_SUCCESS = exports.REGISTRATION_STEP_CONFIRMED_SUCCESS = 'REGISTRATION_STEP_CONFIRMED_SUCCESS';


//////////////////
// WEBPACK FOOTER
// ./src/components/Registration/constants.js
// module id = 757
// module chunks = 0